import { DiscussionSortOption } from './types';

export enum DISCUSSION {
  QUESTIONS = 'questions',
  REVIEWS = 'reviews',
}

export enum DEAL_COMMENT_TYPE {
  REVIEW = 'dealreview',
  QUESTION = 'dealcomment',
}

export const getQuestionSortOptions = ({
  isPartner = false,
}: {
  isPartner: boolean;
}): DiscussionSortOption[] => {
  if (isPartner) {
    return [
      { value: 'newest', label: 'Newest' },
      { value: 'latest', label: 'Latest reply' },
      { value: 'helpful', label: 'Helpful' },
      { value: 'oldest', label: 'Oldest' },
    ];
  }

  return [
    { value: 'latest', label: 'Latest reply' },
    { value: 'helpful', label: 'Helpful' },
    { value: 'newest', label: 'Newest' },
    { value: 'oldest', label: 'Oldest' },
  ];
};

export const REVIEW_SORT_OPTIONS: DiscussionSortOption[] = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'rating:asc', label: 'Rating (Lowest)' },
  { value: 'rating:desc', label: 'Rating (Highest)' },
  { value: 'helpful', label: 'Helpful' },
];

export const ITEMS_PER_PAGE_ON_DEAL = 5;
export const ITEMS_PER_PAGE_ON_AGGREGATE = 20;
export const REPLY_MAX_LENGTH = 5000;
export const REVIEW_TITLE_MAX_LENGTH = 250;
export const MAX_LEVEL_REPLY_ALLOWED = 2; // staring from 0
